import { AxiosResponse } from 'axios';
import api from '../api';
import { ASSIGNED_STATUS, ASSIGNED_TYPE } from '../constants/assigned.constant';
import { GENDER } from '../constants/common.constant';
import { SORT_ORDER } from '../constants/filter.constant';
import {
  DefaultResponse,
  Institution,
  InstitutionProp,
  Procedure,
  User,
  UserResponse,
} from '../interfaces/index';

const ASSIGN_URL = '/orders/v1/assign';

export interface ParamsGetAssigns {
  assigned_at_from?: string;
  assigned_at_to?: string;
  institution_ids?: string[];
  limit?: number;
  name?: string;
  offset?: number;
  order_group?: string;
  order_id?: string;
  patient_id?: string;
  patient_name?: string;
  sort_field?: '' | 'created_at';
  sort_order?: SORT_ORDER;
  status?: ASSIGNED_STATUS;
  study_desc?: string;
  type?: ASSIGNED_TYPE;
  visit_id?: string;
}
export interface ResponseGetAssigns extends DefaultResponse {
  data: {
    assign_groups: {
      active: boolean;
      created_at: string;
      creator_id: string;
      id: string;
      institution_ids: string[];
      institutions: Institution[];
      name: string;
      updated_at: string;
    }[];
    assign_ids: string[];
    assign_users: User[];
    created_at: string;
    updated_at: string;
    creator_id: string;
    id: string;
    order_id: string;
    status: ASSIGNED_STATUS;
    type: ASSIGNED_TYPE;
    order: {
      created_at: string;
      device_id: string;
      diagnostic: string;
      id: string;
      institution: InstitutionProp;
      institution_id: string;
      metadata: null | unknown;
      order_doctor_name: string;
      order_group: string;
      patient_arrived_time: string;
      procedure: Procedure;
      procedure_id: string;
      refer_doctor_name: string;
      scheduled_date: string;
      source: number;
      status: number;
      study_id: string;
      study: {
        id: string;
        study_instance_uid: string;
        study_date: string;
        patient_age: string;
      };
      updated_at: string;
      user: UserResponse;
      user_id: string;
      visited_patient: {
        address: string;
        birth_date: string;
        email: string;
        name: string;
        patient_id: string;
        phone: string;
        sex: GENDER;
        visit_id: string;
      };
      visited_patient_id: string;
    };
  }[];
}
export const getAssigns = async (params: ParamsGetAssigns = {}) => {
  const response = (await api({
    url: ASSIGN_URL,
    method: 'GET',
    params,
    timeout: 30_000,
  })) as AxiosResponse<ResponseGetAssigns>;

  return response.data;
};

export interface ResponseGetAssignDetail extends DefaultResponse {
  data: {
    assign_groups: any[];
    assign_id: string[];
    assign_users: User[];
    created_at: string;
    updated_at: string;
    creator_id: string;
    id: string;
    order_id: string;
    status: number;
    type: number;
    order: {
      created_at: string;
      device_id: string;
      diagnostic: string;
      id: string;
      institution: InstitutionProp;
      institution_id: string;
      metadata: null | unknown;
      order_doctor_name: string;
      order_group: string;
      patient_arrived_time: string;
      procedure: Procedure;
      procedure_id: string;
      refer_doctor_name: string;
      scheduled_date: string;
      source: number;
      status: number;
      study_id: string;
      updated_at: string;
      user: UserResponse;
      user_id: string;
      visited_patient: {
        address: string;
        birth_date: string;
        email: string;
        name: string;
        patient_id: string;
        phone: string;
        sex: GENDER;
        visit_id: string;
      };
      visited_patient_id: string;
    };
  };
}
export const getDetailAssign = async (id: string) => {
  const response = (await api({
    url: `${ASSIGN_URL}/${id}`,
    method: 'GET',
  })) as AxiosResponse<ResponseGetAssignDetail>;

  return response.data;
};

export interface VisitedPatient {
  age: number;
  birth_date: string;
  id: string;
  patient_id: string;
  patient_name: string;
  sex: string;
  visit_id: string;
}
export interface ParamsCreateAssign {
  assign_ids: string[];
  order_id: string;
  type: ASSIGNED_TYPE;
}
export const createAssign = async (data: ParamsCreateAssign) => {
  const response = (await api({
    url: ASSIGN_URL,
    method: 'POST',
    data,
  })) as AxiosResponse<any>;

  return response.data;
};

export interface ParamsUpdateAssign {
  id: string;
  assign_ids: string[];
  type: ASSIGNED_TYPE;
}
export const updateAssign = async (data: ParamsUpdateAssign) => {
  const response = (await api({
    url: ASSIGN_URL + '/' + data.id,
    method: 'PUT',
    data,
  })) as AxiosResponse<any>;

  return response.data;
};

export interface ParamsDeleteAssign {
  id: string;
}
export const deleteAssign = async (data: ParamsDeleteAssign) => {
  const response = (await api({
    url: ASSIGN_URL + '/' + data.id,
    method: 'DELETE',
  })) as AxiosResponse<any>;

  return response.data;
};
